import { useEffect, useRef } from "react";

export const useScrollToActiveTab = (selectedTabId: string | null) => {
  const viewportRef = useRef<HTMLDivElement | null>(null);
  const tabRefs = useRef<Record<string, HTMLDivElement | null>>({});

  useEffect(() => {
    if (!selectedTabId || !viewportRef.current) return;

    const tabElement = tabRefs.current[selectedTabId];
    const viewport = viewportRef.current;

    if (tabElement) {
      const stickyWidth = 48; // width of the sticky Tests (group) tab

      const { left: tabLeft, right: tabRight } =
        tabElement.getBoundingClientRect();
      const { left: viewportLeft, right: viewportRight } =
        viewport.getBoundingClientRect();

      const adjustedViewportLeft = viewportLeft + stickyWidth;

      if (tabLeft < adjustedViewportLeft || tabRight > viewportRight) {
        tabElement.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "center",
        });
      }
    }
  }, [selectedTabId]);

  return {
    viewportRef,

    registerTabRef: (id: string, el: HTMLDivElement | null) => {
      if (el) tabRefs.current[id] = el;
    },
  };
};
